export default __webpack_public_path__ + "static/media/98.e337f08b.jpeg";